<script lang="ts" setup>
import { setupAuthOnClient } from '@operations/client';
import { useAuth } from '@shared/logto/vue';
import { useRouter } from 'vue-router';

const { token, fetchToken, setupRouter } = useAuth();

setupRouter(useRouter());
setupAuthOnClient({ token, fetchToken });
</script>

<template>
  <slot />
</template>
